/**
 * useCUALoopEvents — SSE subscription for CUA loop detection events
 * Reference: TASK-UI-CU-007-2, SOL-UI-CU-007
 */

import { useState, useCallback } from 'react';
import { useWorkspaceEvents } from '@/shared/hooks/useWorkspaceEvents';

export interface CUALoopEvent {
  session_id: string;
  reason: string;
  pa?: string;
}

export function useCUALoopEvents() {
  const [loopEvent, setLoopEvent] = useState<CUALoopEvent | null>(null);

  useWorkspaceEvents('agent.cua.loop.detected', (payload: unknown) => {
    const event = payload as CUALoopEvent;
    if (event?.session_id) {
      setLoopEvent(event);
    }
  });

  const dismiss = useCallback(() => setLoopEvent(null), []);

  return { loopEvent, dismiss };
}
